import { render, staticRenderFns } from "./FamilyActionButtons.vue?vue&type=template&id=c74a547a&scoped=true&"
import script from "./FamilyActionButtons.vue?vue&type=script&lang=ts&"
export * from "./FamilyActionButtons.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyActionButtons.vue?vue&type=style&index=0&id=c74a547a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74a547a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VRow,VTooltip})
